import React from 'react';
import { Typography, Stack, Button } from '@mui/material';

import BodyPartImage from '../assets/icons/body-part.png';
import TargetImage from '../assets/icons/target.png';
import EquipmentImage from '../assets/icons/equipment.png';

const Details = ({exerciseDetail}) => {

const {bodyPart, gifUrl, name, target, equipment} = exerciseDetail;

const extraDetail = [
    {
        icon: BodyPartImage,
        name: bodyPart,
    },
    {
        icon: TargetImage,
        name: target,
    },
    {
        icon: EquipmentImage,
        name: equipment,
    },
]


  return (
    <Stack  sx={{ flexDirection: { lg: 'row' }, p: '20px', alignItems: 'center' }}>
    <img src={gifUrl} alt={name} loading="lazy" className="detail-image" />
    <Stack sx={{ gap: { lg: '35px', xs: '20px' } }}>
        
        <Typography variant='h3' style={{ textTransform: 'capitalize' }}>
          {name}
        </Typography>

        <Typography variant='h5'>
        Be physically active. "<span style={{ textTransform: 'capitalize' }}>{name}</span>" is one of the best<br/> exercises to target your "{target}". It will help you improve your<br/> brain health, help manage weight, reduce the risk of disease, strengthen bones and muscles, and improve your ability to do everyday activities.
        </Typography>
        {extraDetail.map((item) => (
            <Stack key={item.name} direction="row" gap="24px" alignItems="center">
            <Button sx={{ background: '#ffff',border: '2px solid #e2e8f0' ,borderRadius: '50%', width: '100px', height: '100px' }}>
                <img src={item.icon} alt={bodyPart} style={{ width: '50px', height: '50px' }} />
            </Button>
            <Typography variant='h6' textTransform='capitalize'>
                {item.name}
            </Typography>
            </Stack>
        ))}

    </Stack>
    </Stack>
  )
}

export default Details